// Localization
import { I18n } from "i18n-js";

// i18n locales
import en from "../locale/en-US";
const i18n = new I18n({
  en,
  ["en-US"]: en,
});

i18n.enableFallback = true;
i18n.defaultLocale = "en";
export default i18n;
